<div class="shadow">
  <div class="flex justify-between items-center">
    <div [ngClass]="['button-container', getImageUrl(item) ? '' : 'relative']">
      @if ((multiImageDownloadActive$ | async) === false) {
        <pc-shared-add-to-favorites-button
          (afterAdd)="onAfterAddToFavorites()"
          (beforeAdd)="$event.stopPropagation()"
          [config]="addToFavoritesButtonConfig"
        ></pc-shared-add-to-favorites-button>
      }
      <cat-multi-image-download-checkbox
        [coreId]="coreId"
        [image]="getImageUrl(item)"
        [recordId]="item.header.id"
        [title]="item.GulliverTabName"
        [type]="item.GulliverRecType"
      ></cat-multi-image-download-checkbox>
    </div>

    <div [ngClass]="['image-preview-button-container', getImageUrl(item) ? '' : 'relative']">
      <cat-lightbox-button [index]="index" [searchId]="searchId"></cat-lightbox-button>

      @if ((multiImageDownloadActive$ | async) === false) {
        <cat-image-preview-button [coreId]="coreId"
                                  [item]="item"></cat-image-preview-button>
      }
    </div>
  </div>

  <div [ngClass]="['img-container', opened ? 'highlight' : '', active ? 'active' : '']">
    @if (getImageUrl(item)) {
      <img [alt]="getLabel()" [src]="getImageUrl(item) | safe" width="100%"/>
    }

    <div class="p-2">
      @if (item.header.label && (!item.header.label.firstOnly || item.showLabel)) {
        <div
          [innerHTML]="getLabel(true)"
          [title]="getLabel()"
          class="label mat-title-medium text-gray"
        ></div>
      }

      @if (item.header.sublabel && (!item.header.sublabel.firstOnly || item.showSublabel)) {
        <div
          [innerHTML]="item.header.sublabel.value"
          class="mat-title-small sublabel"
        ></div>
      }

      @if (item.header.additional && (!item.header.additional.firstOnly || item.showAdditional)) {
        <div
          [innerHTML]="item.header.additional.value"
          class="text-gray mat-body-medium mt-2 hidden md:block"
        ></div>
      }
    </div>
  </div>
</div>
